import React from "react";
import PageWrapper from "./activity.style";
import PageTitle from "components/common/PageTitle";
import { connect } from "react-redux";
import ActivityTable from "../../components/activity/ActivityTable";

const Activity = props => {
  return (
    <PageWrapper {...props}>
      <PageTitle
        props={props}
        title="sidebar.notification"
        className="plr-15"
        breadCrumb={[
          {
            name: "sidebar.dashboard",
            url: "/dashboard"
          },
          {
            name: "sidebar.notification"
          }
        ]}
      />
      <div className="user-tbl">
        <ActivityTable {...props} />
      </div>
    </PageWrapper>
  );
};

const mapStateToProps = state => {
  return {
    rd_id: state.auth.id,
    service_id: state.auth.service_id,
    ...state.themeChanger
  };
};

export default connect(mapStateToProps, null)(Activity);
